import * as React from 'react';
import { JSX } from 'react';
import styled from '@emotion/styled';
import { css, keyframes, CSSObject } from '@emotion/react';

export enum AnimatedCollectionType {
  SLIDE_IN_LEFT = 'SLIDE_IN_LEFT',
  FADE_IN = 'FADE_IN'
}

export interface AnimatedCollectionProps<T> {
  children: T[];
  type: AnimatedCollectionType;
  generate_inner: (element: T) => JSX.Element;
  generate_outer_class?: (element: T) => CSSObject;
}

export function AnimatedCollection<T>(props: AnimatedCollectionProps<T>) {
  return (
    <>
      {props.children.map((c, index) => {
        let element_inner = props.generate_inner(c);
        let extra_class = props.generate_outer_class?.(c);

        return (
          <S.Element css={extra_class} type={props.type} delay={index * 50} key={element_inner.key}>
            {element_inner}
          </S.Element>
        );
      })}
    </>
  );
}
namespace S {
  const initialSlide = css`
    transform: translateX(-30px);
    opacity: 0;
  `;

  const initialFade = css`
    opacity: 0;
  `;

  export const SlideIn = keyframes`
    0%{
      ${initialSlide};
    }
    100%{
      transform: translateX(0);
      opacity: 1;
    }
  `;

  export const FadeIn = keyframes`
    0% {
      ${initialFade};
    }
    100% {
      opacity: 1;
    }
  `;

  export const Element = styled.div<{ delay: number; type: AnimatedCollectionType; css?: any }>`
    animation-delay: ${(p) => p.delay}ms;
    animation-name: ${(p) =>
      ({
        [AnimatedCollectionType.FADE_IN]: FadeIn,
        [AnimatedCollectionType.SLIDE_IN_LEFT]: SlideIn
      })[p.type]};
    animation-duration: 0.4s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;

    ${(p) =>
      ({
        [AnimatedCollectionType.FADE_IN]: initialFade,
        [AnimatedCollectionType.SLIDE_IN_LEFT]: initialSlide
      })[p.type]};

    ${(p) => p.css};
  `;
}
